module.exports = __webpack_public_path__ + "img/logo.525e0e37.png";